import React from 'react';

/**
 * Handwritten-style founder note. Renders as a paper card with a slight tilt,
 * a torn/washi tape corner, and the note in Dancing Script.
 */
const FounderNote = () => {
  return (
    <section className="bg-[#efe9db]" data-testid="founder-note-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24">
        <div className="text-center mb-10">
          <div className="uppercase tracking-[0.35em] text-xs text-[#7a8b6b] mb-3">A note from us</div>
          <h2 className="section-title text-4xl md:text-5xl">Straight From Our Hearth To Yours</h2>
        </div>

        <div className="relative mx-auto max-w-2xl">
          {/* Washi tape accents */}
          <div
            aria-hidden="true"
            className="absolute -top-3 left-8 w-24 h-6 bg-[#cfd8c2]/80 rotate-[-6deg] shadow-sm"
          />
          <div
            aria-hidden="true"
            className="absolute -top-3 right-10 w-20 h-6 bg-[#e9d8c4]/80 rotate-[5deg] shadow-sm"
          />

          {/* Paper card */}
          <div
            className="relative bg-[#faf7f1] p-10 md:p-14 shadow-xl rotate-[-0.6deg]"
            style={{
              backgroundImage:
                'repeating-linear-gradient(0deg, transparent, transparent 34px, rgba(122,139,107,0.08) 35px)',
            }}
            data-testid="founder-note-card"
          >
            <p className="font-script text-2xl md:text-3xl leading-[1.7] text-[#3a4a3b]">
              Hi love &mdash;
            </p>
            <p className="font-script text-2xl md:text-3xl leading-[1.7] text-[#3a4a3b] mt-4">
              Herbs We Love began at our own kitchen table, brewing simple remedies for the people
              we love most. We believed then, as we do now, that food can be medicine and that
              nature already gives us what our bodies are asking for.
            </p>
            <p className="font-script text-2xl md:text-3xl leading-[1.7] text-[#3a4a3b] mt-4">
              Every elixir, salve and syrup you hold is poured in small batches with real herbs,
              patient hands and the hope that it helps you feel a little more whole. Thank you for
              letting us be a small part of your ritual.
            </p>
            <p className="font-script text-2xl md:text-3xl leading-[1.7] text-[#3a4a3b] mt-6">
              With love and gratitude,
            </p>
            <p className="font-script text-3xl md:text-4xl text-[#7a8b6b] mt-2">
              The Herbs We Love Family
            </p>

            {/* Little sprig accent */}
            <div className="mt-6 flex items-center gap-2 text-[#7a8b6b]">
              <span className="inline-block h-px w-10 bg-[#7a8b6b]/50" />
              <span className="text-xs uppercase tracking-[0.35em]">Herbs. Healing. Heart.</span>
              <span className="inline-block h-px w-10 bg-[#7a8b6b]/50" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;
